export const LOADING_NEW_HOME = "LOADING_NEW_HOME";
export const GET_NEW_HOME = "GET_NEW_HOME";
export const GET_NEW_PEOPLE = "GET_NEW_PEOPLE";
export const REFRESH_NEW_HOME = "REFRESH_NEW_HOME";
export const PAGINATE_HOME = "PAGINATE_HOME";
export const LOADING_HOME_CONTENTS = "LOADING_HOME_CONTENTS";
